/** @file Exact equality of two per-vertex influence lists (the W2-31 no-op test of the weight commands). */
import type { Id } from '@pose2d/format/types';

type Lists = readonly (readonly (readonly [Id, number])[])[];

/** True when both hold the same [bone, weight] pairs, in the same order, for every vertex. */
export function sameWeights(a: Lists, b: Lists): boolean {
  return a.length === b.length && a.every((v, i) => {
    const u = b[i] ?? [];
    return v.length === u.length && v.every(([bone, w], j) => u[j]?.[0] === bone && u[j][1] === w);
  });
}
